import { ChangeEvent, SyntheticEvent, MouseEvent, FocusEvent, KeyboardEvent, useCallback } from 'react';
import cn from 'classnames';

import { Button } from './Button';
import { TextInput } from './TextInput';
import styles from './SearchInput.module.scss';

export interface ISearchFieldProps {
  value?: string | number;
  className?: string;
  id?: string;
  name: string;
  placeholder?: string;
  autoFocus?: boolean;
  invalid?: boolean;
  disabled?: boolean;
  buttonDisabled?: boolean;
  error?: string;
  onInput?: (e: SyntheticEvent) => void;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  onSubmit?: () => void;
}

export const SearchInput = ({
  className = '',
  buttonDisabled,
  error,
  onClick,
  onSubmit,
  ...rest
}: ISearchFieldProps) => {
  const handleTextInputKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        onSubmit?.();
      }
    },
    [onSubmit],
  );

  const onSubmitClick = useCallback(() => {
    onSubmit?.();
  }, [onSubmit]);

  return (
    <div className={cn([styles.SearchField, className])}>
      <div className={styles.Content}>
        <TextInput className={styles.Input} onKeyDown={handleTextInputKeyDown} {...rest} />
        <Button
          className={styles.Button}
          id="searchButton"
          color="primary"
          text="Искать"
          onClick={onSubmitClick}
          disabled={buttonDisabled}
        />
      </div>
      {error && <div className={styles.Error}>{error}</div>}
    </div>
  );
};
